import { ImportacaoErroList } from './components/ImportacaoErroList'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'

const ImportacaoErroPage = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ImportacaoErroList />
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { ImportacaoErroPage }
